// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileFeed-cls1_1PO","cls2":"ProfileFeed-cls2_I9w ProfileFeed-cls1_1PO"};